export default "__VITE_ASSET__Ba5lpWh___"